module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pages-home-block', {
    attrs: {
      "block": _vm.block
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b54034e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/infoReviewers/OurMission.vue
// module id = 286
// module chunks = 0